import { DraggableAttributes, DragOverlay } from "@dnd-kit/core";
import { useState } from "react";

import { SortableItem, SortableList } from "@smart/itops-sb-design-system-dom";

import { CustomiseFieldRow } from "./customise-field-row";
import { NewFieldOptions } from "../../types";

export type CustomiseFieldListProps = {
  fields: NewFieldOptions[];
  onReorder: (activeId: string, overId: string) => void;
  onEditLabel: (uri: string, label: string) => void;
  onCommitLabel: (uri: string) => void;
  onRemove: (uri: string) => void;
};

export const CustomiseFieldList = ({
  fields,
  onReorder,
  onEditLabel,
  onCommitLabel,
  onRemove,
}: CustomiseFieldListProps) => {
  const [activeId, setActiveId] = useState<string>();
  const hasMultipleFields = fields.length > 1;
  const activeIndex = fields.findIndex((field) => field.uri === activeId);

  return (
    <SortableList
      itemKeys={fields.map((field) => field.uri)}
      onDragStart={({ active }) => {
        setActiveId(active.id as string);
      }}
      onDragEnd={({ active, over }) => {
        setActiveId(undefined);
        if (over?.id) onReorder(active.id as string, over.id as string);
      }}
    >
      <div className="flex flex-col gap-small">
        {fields.map((field, index) => (
          <SortableItem
            key={field.uri}
            id={field.uri}
            disabled={!hasMultipleFields}
          >
            {({ dragHandleProps, isDragging }) => (
              <CustomiseFieldRow
                field={field}
                index={index}
                dragHandleProps={dragHandleProps}
                isDragging={isDragging}
                canReorder={hasMultipleFields}
                canRemove={hasMultipleFields}
                onEditLabel={onEditLabel}
                onCommitLabel={onCommitLabel}
                onRemove={onRemove}
              />
            )}
          </SortableItem>
        ))}
      </div>
      <DragOverlay>
        {activeId && activeIndex >= 0 ? (
          <div className="cursor-grab">
            <CustomiseFieldRow
              field={fields[activeIndex]}
              index={activeIndex}
              dragHandleProps={{
                attributes: {} as DraggableAttributes,
                listeners: {},
              }}
              isDragging={false}
              canReorder={hasMultipleFields}
              canRemove={hasMultipleFields}
              onEditLabel={() => {}}
              onCommitLabel={() => {}}
              onRemove={() => {}}
            />
          </div>
        ) : null}
      </DragOverlay>
    </SortableList>
  );
};
